// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__w0fuc","left":"StickyBox_left__38puZ","right":"StickyBox_right__3lpWL"};